require 'jquery-mousewheel/jquery.mousewheel.js'

MPP.NearbyDealsMap or= {}

MPP.NearbyDealsMap.Carousel = class Carousel

  constructor: (@selector, @parentSelector) ->
    @$parent = $ @parentSelector
    @$el = $ @selector
    @tiles = @$el.children 'li'
    @tileHighlightClass = 'c-bg-ntc'
    @makeHoverable()

  clearHighlight: ->
    @tiles.removeClass 'highlighted'
    @tiles.find('.tile-num').removeClass @tileHighlightClass

  scrollToTile: (num) ->
    return unless num? and num <= @tiles.length

    @clearHighlight()
    target = $ "#tile_#{num}"
    @$parent.stop().scrollTo target, 400
    @setHighlighted(target)

  setHighlighted: (target) ->
    target.addClass 'highlighted'
    target.find('.tile-num').addClass @tileHighlightClass

  goToDealPage: (num) ->
    return unless num? and num <= @tiles.length

    target = $ "#tile_#{num}"
    targetDealUrl = target.find('figcaption a').attr 'href'
    window.location = targetDealUrl if targetDealUrl?.length

  makeHoverable: ->
    that = this

    @tiles.hover(
      ->
        tile = $ this
        tileNumber = tile.attr 'data-tile'
        that.clearHighlight()
        that.setHighlighted(tile)
        MPP.NearbyDealsMap.markers?[tileNumber - 1].find('.marker-label').addClass('active c-txt-ntc c-bdr-ntc')
      ->
        that.clearHighlight()
        tileNumber = $(this).attr 'data-tile'
        MPP.NearbyDealsMap.markers?[tileNumber - 1].find('.marker-label').removeClass('active c-txt-ntc c-bdr-ntc')
    )
